import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { toMillis } from '@/utils/folder.utils';
import { getTimeDiffInWords } from '@/utils/date.utils';
import { I18N_KEYS } from '@/language/keys';
import { color } from '@/colors';
import { FlexCenHorVer, FlexCol } from '@/UI/styles';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { TextSmRg, TextStdRg } from '@/UI/AppTypography/AppTypography';
import WorkflowCardDisplay from '../components/WorkflowCardDisplay';
import { DashboardCard } from '../DashboardCard';
import type { ArchiveItem } from './archive.types';

interface ArchiveWorkflowCardProps {
  item: ArchiveItem;
  onRestore: (id: string, type: 'workflow' | 'folder') => void;
  isRestoring?: boolean;
}

const ArchiveWorkflowCard = ({ item, onRestore, isRestoring }: ArchiveWorkflowCardProps) => {
  const { t } = useTranslation();

  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
      <DashboardCard>
        <WorkflowCardDisplay
          poster={item.poster}
          forceShowOverlay={isRestoring}
          hoverOverlay={
            <FlexCenHorVer
              sx={{
                position: 'absolute',
                inset: 0,
                backgroundColor: color.Black40_T,
              }}
            >
              <ButtonContained
                size="small"
                endIcon={isRestoring && <CircularProgress size={14} sx={{ color: 'inherit' }} />}
                onClick={() => onRestore(item.id, item.itemType)}
                sx={{ pointerEvents: isRestoring ? 'none' : 'auto' }}
              >
                {t(I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE)}
              </ButtonContained>
            </FlexCenHorVer>
          }
        />
        <FlexCol sx={{ pl: 1, pt: 1, pb: 3, pr: 2 }}>
          <TextStdRg noWrap text={item.name} color={color.White100} />
          <TextSmRg
            noWrap
            text={t(I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.DELETED_AT, {
              date: getTimeDiffInWords(toMillis(item.deletedAt)),
            })}
            color={color.White64_T}
          />
        </FlexCol>
      </DashboardCard>
    </Grid2>
  );
};

export default ArchiveWorkflowCard;
